import React from 'react';
import {createBrowserRouter, Navigate, RouterProvider} from 'react-router-dom';
import {Loader} from '@KrashidBuilt/hotsauce-common/dist/components'
import Main from "../wrapper/Main";
import Routes from './Routes';
import Error from "../screens/Error";

const Router = () => {
    const router = createBrowserRouter(
        [...Routes.map((RouteElement, index) => ({
            path: RouteElement.path,
            element: (<RouteElement.component/>)

        })),
            {path: '/', element: <Navigate replace to="/login"/>, errorElement: <Error/>}
        ]
    );
    return (
        <Main>
            <RouterProvider
                router={router}
                fallbackElement={<Loader/>}
            />
        </Main>
    );
};


export default Router;

